(function ($) {

    $(function () {

        var regExp = /^([\w\.\+]{1,})([^\W])(@)([\w]{1,})(\.[\w]{1,})+$/;

        $('.promo-block-email .column-wrapper .form-wrap form #email1, .promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email, .promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email--2').on('keyup', function () {

            regExp.test($(this).val()) ? $('.promo-block-email .column-wrapper .form-wrap form .message').removeClass('show') : $('.promo-block-email .column-wrapper .form-wrap form .message').addClass('show');
            if ($('.promo-block-email .column-wrapper .form-wrap form .message').hasClass('show')) {
                $(this).parents('form').find('#email1').css({'border': '2px solid #98002e'});
                $(this).parents('form').find('#edit-mergevars-email').css({'border': '2px solid #98002e'}); 
                $(this).parents('form').find('#edit-mergevars-email--2').css({'border': '2px solid #98002e'});  
            }
            else {
                $('body .inner-overlay .form-container form #email1').css({'border': '1px solid #B9B9B9'});
                $('body .inner-overlay .form-container form #edit-mergevars-email').css({'border': '1px solid #B9B9B9'});
                $('body .inner-overlay .form-container form #edit-mergevars-email--2').css({'border': '1px solid #B9B9B9'});
            }

            if ($(this).val() == "") {
                $(this).parent().find('label[for="email1"]').removeClass('email1-label');
                $(this).parent().find('label[for="edit-mergevars-email"]').removeClass('email1-label');
                $(this).parent().find('label[for="edit-mergevars-email--2"]').removeClass('email1-label');
                $('.promo-block-email .column-wrapper .form-wrap form #email1').css({'border': '1px solid #cb0000'});
                $('.promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email').css({'border': '1px solid #cb0000'});
                $('.promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email--2').css({'border': '1px solid #cb0000'});
            } else {
                $(this).parent().find('label[for="email1"]').addClass('email1-label');
                $(this).parent().find('label[for="edit-mergevars-email"]').addClass('email1-label');
                $(this).parent().find('label[for="edit-mergevars-email--2"]').addClass('email1-label');
                $(this).parents('form').find('#email1').css({'border': '2px solid #98002e'});
                $(this).parents('form').find('#edit-mergevars-email').css({'border': '2px solid #98002e'});
                $(this).parents('form').find('#edit-mergevars-email--2').css({'border': '2px solid #98002e'});
            }
        });

        $('.promo-block-email .column-wrapper .form-wrap form #email1, .promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email, .promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email--2').on('blur', function () {
            if ($('.promo-block-email .column-wrapper .form-wrap form .message').hasClass('show')) {
                $('.promo-block-email .column-wrapper .form-wrap form #email1').css({'border': '1px solid #cb0000'});
                $('.promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email').css({'border': '1px solid #cb0000'});
                $('.promo-block-email .column-wrapper .form-wrap form #edit-mergevars-email--2').css({'border': '1px solid #cb0000'});
            }
            // else if ($('body .promo-block-email .column-wrapper .form-wrap form label').hasClass('email1-label')) {
            //     $('.promo-block-email .column-wrapper .form-wrap form #email1').css({'border': '2px solid #98002e'});
            // }
            else {
                $(this).css({'border': '1px solid #f8f8f8'});
                $('.promo-block-email .column-wrapper .form-wrap form label[for="email1"]').addClass('email1-label-color');
                $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email"]').addClass('email1-label-color');
                $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email--2"]').addClass('email1-label-color');
            }
        }).on('focus', function () {
            $(this).css({'border': '2px solid #98002e'});
            $('.promo-block-email .column-wrapper .form-wrap form label[for="email1"]').addClass('email1-label');
            $('.promo-block-email .column-wrapper .form-wrap form label[for="email1"]').removeClass('email1-label-color');
            $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email"]').addClass('email1-label');
            $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email"]').removeClass('email1-label-color');
            $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email--2"]').addClass('email1-label');
            $('.promo-block-email .column-wrapper .form-wrap form label[for="edit-mergevars-email--2"]').removeClass('email1-label-color');
        });

    });

})(jQuery);